
        import * as module0 from '$components/minimal-theme.switcher.js'
        const modules = {
            "minimal-theme.switcher.js": module0,
        };
        export default modules;
      